import React, { useState, useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom';

import Layout from '../../../../components/Layout';
import { AuthUser } from '../../../../components/AuthUser';
import { DetalleFactura } from './DetalleFactura';

import { RequestPage, getVendedor } from '../../../../api/request';
import { Facturas } from '../../../../api/requestFacturas';

import Pagination from 'react-responsive-pagination';

export const ConsultaFacturasVendedor = () => {

  const params = useParams()
  const navigate = useNavigate()

  // State del usuario
  const { user } = AuthUser();

  // States para los datos
  const [Factura, setFactura] = useState([]);
  const [Vendedor, setVendedor] = useState();

  // States de paginas
  const [page, setPage] = useState('');
  const [totalPages, setTotalPages] = useState('');
  const [urlPage, setUrlPage] = useState('');
  const [currentPage, setCurrentPage] = useState(0);

  // State del loading
  const [loading, setLoading] = useState(true);

  // States de busqueda
  const [term, setTerm] = useState('');
  const [searchTerm, setSearchTerm] = useState('')
  const [notFound, setNotFound] = useState(false);
  const [searching, setSearching] = useState(false);
  const [inicio, setInicio] = useState('');
  const [fin, setFin] = useState('');

  const loadFacturas = async () => {
    setLoading(true)
    const res = await Facturas(params.codigo);
    const vendorInfo = await getVendedor(params.codigo)
    setPage(res.meta.current_page)
    setTotalPages(res.meta.last_page)
    setUrlPage(res.links.first)

    setFactura(res.data)
    setVendedor(vendorInfo)
    setLoading(false)
  }

  const loadPage = async (pageData) => {
    setLoading(true)

    const facturaData = await RequestPage(pageData);

    if (searchTerm) {
      setPage(facturaData.current_page)
      setTotalPages(facturaData.last_page)
      setUrlPage(facturaData.first_page_url)
    } else {
      setPage(facturaData.meta.current_page)
      setTotalPages(facturaData.meta.last_page)
      setUrlPage(facturaData.links.first)
    }

    setFactura(facturaData.data)
    setLoading(false)
  }

  const handlePageChange = async (page) => {
    setCurrentPage(page)
    if (searchTerm) {
      switch (searchTerm) {
        case 'Fecha':
          loadPage(urlPage.replace(/.$/, page + `&CodUsuario=${user.CodVendedor}&fechaInicio=${inicio}&fechaFin=${fin}&whatToSearch=${searchTerm}`))
          break;

        default:
          loadPage(urlPage.replace(/.$/, page + `&CodUsuario=${user.CodVendedor}&Busqueda=${term}&whatToSearch=${searchTerm}`))
          break;
      }
    } else {
      loadPage(urlPage.replace(/.$/, page))
    }
  }

  useEffect(() => {
    loadFacturas();
  }, []);

  return (
    <>
      <Layout>
        {/* Cuerpo de la página */}
        {
          (loading) ?
            <>
              <div style={{ position: 'fixed', left: '50%', top: '50%', transform: 'translate(-50%, -50%)' }}>
                <span className="loader-documentos"></span>
              </div>
            </> :
            <>
              {user.CodGerente !== null && (
                <button 
                  className="btn btn-principal btn-hover-details m-2"
                  onClick={() => {
                    navigate('/dashboard-supervisor', {
                      state: { openModal: 'pedidosPorDia' }
                    });
                  }}
                >
                  Ir a Estadisticas de Ayer
                </button>
              )}
              {/* Cabecera */}
              <div className="consultas-title pt-5">
                <h4 className='bg-belmeny text-light px-5 rounded-pill'>Consulta de Facturas</h4>
              </div>

              <h5 className="text-center mt-2 mb-4 text-belmeny"><i>
                {
                  (user.CodGerente !== null) ?
                    <>
                      Supervisor / Gerente - {user.Nombre} - {user.CodVendedor}
                    </> :
                    <>
                      Vendedor - {user.Nombre} - {user.CodVendedor}
                    </>
                }
              </i></h5>

              {/* Body for desktop version */}
              <div className="container-fluid d-md-block d-none  mb-3">
                <div className="rounded-0 my-2">
                  {
                    (notFound) ?
                      <>
                        <div className="alert alert-danger text-center" role="alert">
                          <h5>No se encontraron resultados</h5>
                        </div>
                      </> :
                      <>
                        <table className='table table-bordered table-hover border-belmeny '>
                          <thead className='bg-belmeny text-light text-center'>
                            <tr>
                              <th>Factura</th>
                              <th>Cliente</th>
                              {(user.CodGerente !== null) ? <th>Vendedor</th> : null}
                              <th>Monto</th>
                              <th>Fecha</th>
                              <th style={{ width: "15%" }}>Opciones</th>
                            </tr>
                          </thead>
                          <tbody>
                            {(Factura.map((item) => <DetalleFactura item={item} vendedor={Vendedor[0].Nombre} key={item.Documento} />))}
                          </tbody>
                        </table>
                      </>
                  }
                </div>

                <Pagination
                  total={totalPages}
                  current={currentPage}
                  onPageChange={page => handlePageChange(page)}
                />
              </div>

              {/* Body for mobile version */}
              <div className="container-fluid d-sm-block d-md-none">
                {
                  (notFound) ?
                    <>
                      <div className="alert alert-danger text-center" role="alert">
                        <h5>No se encontraron resultados</h5>
                      </div>
                    </> :
                    <>
                      <div className="rounded-0 my-2">
                        {(Factura.map((item) => <DetalleFactura item={item} vendedor={Vendedor[0].Nombre} key={item.Documento + "Mobile"} />))}
                      </div>

                      <Pagination
                        total={totalPages}
                        current={currentPage}
                        onPageChange={page => handlePageChange(page)}
                      />
                    </>
                }

                <div className="division bg-belmeny my-3"></div>
              </div>
            </>
        }
      </Layout>
    </>
  )
}
